import React, { Component } from "react";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getNews, getMoreNews } from '../../actions/newsActions';
import moment from 'moment';

class ItemsNews extends Component {

    componentWillMount() {
        this.props.getNews();
    }

    render() {
        return (
            <div className="menu-content-сontacts menu-content-item tab-parent screen-bottom-block">
                <div className="rounded-white-block">
                    <ul className="tab-content unlimited-block tab-content1 items-list">
                        {this.props.news.data.results ? this.props.news.data.results.map((item, index) => {
                            return (
                                <li className="list-item" key={index}>
                                    <div className="top">
                                        <div className="caption">
                                            {item.title}
                                        </div>
                                    </div>
                                    <div className="news-list__desc">
                                        <p className="news-list__text">Дата публикации: {moment(item.created_at).format('DD.MM.YYYY')}</p>
                                    </div>
                                    <div className="news-list__desc">
                                        <p>{item.short_content}</p>
                                    </div>

                                    <div className="actions bottom">
                                        <div></div>
                                        <Link className="small-button" to={`/news/${item.id}`}>
                                            <button>Подробнее</button>
                                        </Link>
                                    </div>

                                </li>
                            )
                        })
                            :
                            ''
                        }
                    </ul>
                </div>
                {this.props.news.data.next !== null ?
                    <div className="big-button without-shadow button-action" style={{ height: "auto", textAlign: "center", marginTop: "30px", marginBottom: "30px" }}>
                        <button
                            className={this.props.news.isFetching ? 'disabled' : ''}
                            onClick={() => {
                                this.props.getMoreNews(this.props.news.data.next);
                            }}>{this.props.news.isFetching ? 'Загружается...' : 'Загрузить еще'}</button>
                    </div>
                    : ''}
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps, { getNews, getMoreNews })(ItemsNews);


// WEBPACK FOOTER //
// ./src/components/News/ItemsNews.js